import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {BaseError} from "../base-error";
import {Store} from "../../../services/store.service";
import {ComponentTabs} from "../../../models/component-tabs";
import {TabRow} from "../../../models/tab-row";
import {ComponentTabControllerService} from "../../../services/form-controller/component-tab-controller.service";
import FormUtils from "../../utils/form-utils.component";
import {TranslatedBaseError} from "../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {IPostMessageEventTarget, PostMessageBridgeFactory} from "@tekool/ngx-post-message-angular-9";
import {IPostMessageBridge} from "@tekool/ngx-post-message-angular-9/src/IPostMessageBridge";
import * as _ from "lodash";
import {ActivatedRoute} from "@angular/router";
import {IGridValidationItem} from "../../../models/grid-validation-item";
import {FormControllerService} from "../../../services/form-controller/form-controller.service";
import {DeterminantControllerService} from "../../../services/registration-controller/determinant-controller.service";

@Component({
  selector: "grid-validation",
  templateUrl: "./grid-validation.component.html",
  styles: [],
  providers: [],
})
export class GridValidationComponent extends TranslatedBaseError implements OnInit, OnDestroy {

  @Input() public serviceId: string;
  @Input() public componentKey: string;
  @Input() public propKey: string;
  @Output() public changed = new EventEmitter();

  public validations: IGridValidationItem[];
  public determinantMapById: { [key: string]: string } = {};

  public newRow: TabRow = new TabRow("", "");
  public selectedRow?: IGridValidationItem;
  public selectedItem?: IGridValidationItem;
  public tempItem?: IGridValidationItem;
  public showDeterminantBuilder: boolean = false;
  public tempDeterminant: any = null;
  public showGridRow: boolean = false;
  public selectedIndex: number;
  public listToggle: boolean = false;
  private messageBridge: IPostMessageBridge;
  private tabComponentData?: any;
  public fields: any[] = [];
  public showDrawerHeader: boolean = true;


  constructor(private route: ActivatedRoute, private componentTabControllerService: ComponentTabControllerService,
              public store: Store,
              public determinantService: DeterminantControllerService,
              @Inject(PostMessageBridgeFactory) private bridgeFactory: PostMessageBridgeFactory,
              toastr: ToastrService, public translateService: TranslateService, private formControllerService: FormControllerService) {
    super(toastr, translateService);
    const parentWindow: IPostMessageEventTarget = window.top;
    const iFrame: IPostMessageEventTarget = window;
    this.validations = [];
    this.messageBridge = bridgeFactory.makeInstance()
      .setEnableLogging(false)
      .connect(iFrame, parentWindow)
      .makeBridge("FormBuilder")
      .addListener("FormBuilder", (messageString: any) => {
        const data = JSON.parse(messageString);
        if (data.event === "receivedCurrentComponent" && data.serviceId === this.serviceId && data.data && data.data.key === this.componentKey) {
          this.tabComponentData = data.data;
          this.load();
        }
      });
  }

  public ngOnInit() {
    if (!this.serviceId && !this.componentKey) {
      this.route.params.subscribe((params) => {
        this.serviceId = params.serviceId;
        this.store.state.common.serviceId = params.serviceId;
        this.getServiceDeterminantKeyName();
        this.formControllerService.getServiceFields(this.serviceId, {filterByType: "number,currency"}).subscribe((fields) => {
          this.fields = fields;
        });
      });
      this.route.queryParamMap.subscribe((queryParams) => {
        this.componentKey = queryParams.get("key");
        this.propKey = queryParams.get("propKey");
      });
    }
    window.top.postMessage([{
      channel: "FormBuilder",
      message: JSON.stringify({event: "receiveCurrentComponent"}),
    }], "*");
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public addNewRow(showDeterminant?: boolean): void {
    const validationItem: IGridValidationItem = {};
    this.validations.push(validationItem);
    if (showDeterminant) {
      this.openDeterminantModal(validationItem);
    } else {
      this.openGridRowModal(validationItem);
    }
  }

  public openDeterminantModal(validationItem: IGridValidationItem) {
    this.selectedRow = validationItem;
    console.log("---openDeterminantModal", this.selectedRow);
    this.showDeterminantBuilder = true;
    this.showAsFullDrawer();
  }

  public closeDeterminantLayer() {
    if (this.selectedRow && this.isDeterminantEmpty(this.selectedRow.determinants)) {
      const index = this.validations.indexOf(this.selectedRow);
      if (index > -1) {
        this.validations.splice(index, 1);
      }
    }
    this.showDeterminantBuilder = false;
    this.selectedRow = null;
    this.tempDeterminant = null;
    this.backAsFramedDrawer();
  }

  public openGridRowModal(selectedItem: IGridValidationItem) {
    this.selectedItem = selectedItem;
    this.tempItem = Object.assign(selectedItem);
    this.showGridRow = true;
    this.showAsFullDrawer();
  }

  public temoupdateDeterminant(eff) {
    this.tempDeterminant = eff.jsonString;
  }

  public get determinantContextLabel(): string | null {
    if (!this.selectedRow) {
      return null;
    }
    if (this.selectedRow.customMessage) {
      return this.selectedRow.customMessage;
    }
    const index = this.validations ? this.validations.indexOf(this.selectedRow) : -1;
    if (index >= 0) {
      return `${this.translateService ? this.translateService.instant("Row") : "Row"} ${index + 1}`;
    }
    return this.translateService ? this.translateService.instant("Row") : "Row";
  }

  public showModalHeader(e) {
    console.log(e);
    this.showDrawerHeader = e;
  }

  public closeGridRowLayer(cancel: boolean = false) {
    if (cancel) {
      this.tempItem = null;
    } else {
      this.selectedItem = this.tempItem;
      this.save();
    }
    this.showGridRow = false;
    this.backAsFramedDrawer();
  }

  public closeEdit() {
    this.store.state.common.determinantSection.topLayer = "list";
    this.store.state.common.determinantSection.determinant = {};
  }

  public setListView(b: boolean) {
    this.listToggle = b;
  }

  public showAsFullDrawer() {
    const windowParent = window.parent.document.querySelector(".component-settings")?.querySelector(".formio-dialog-content > div > div");
    console.log("windowParent", windowParent);
    windowParent.querySelector(":scope > .row");
    windowParent.querySelector(":scope > .row:nth-child(1)")?.classList.add("d-none");
    windowParent.querySelector(":scope > .row:nth-child(2)")?.classList.add("p-0");
    windowParent.querySelectorAll("iframe")?.forEach(iframe => iframe.classList.add("full-drawer"));
    windowParent.querySelectorAll(".page-iframe")?.forEach(iframe => iframe.classList.add("full-drawer-content"));
    windowParent.querySelector(":scope > .row:nth-child(2)")?.querySelector("#myBuilder")?.classList.add("m-0");
    windowParent.querySelector(":scope > .row:nth-child(2)")?.querySelector(".tab-pane.active")?.classList.add("p-0", "m-0");
    // windowParent.querySelector(":scope > .row:last-child")?.classList.add("d-none");
    window.parent.document.querySelector(".component-settings")?.querySelector(".formio-dialog-close")?.classList.add("d-none");
    windowParent.querySelector("#element1")?.querySelector(":scope > .formio-component-tabs")?.querySelector(":scope > div > .nav-tabs")?.classList.add("d-none");
    windowParent.querySelector("#element1")?.querySelector(":scope > .formio-component-tabs")?.querySelector(":scope .formio-component-validationSubTabs .nav-tabs")?.classList.add("d-none");
  }

  public backAsFramedDrawer() {
    const windowParent = window.parent.document.querySelector(".component-settings")?.querySelector(".formio-dialog-content > div > div");
    windowParent.querySelector(":scope > .row:nth-child(1)")?.classList.remove("d-none");
    windowParent.querySelector(":scope > .row:nth-child(2)")?.classList.remove("p-0");
    windowParent.querySelectorAll("iframe")?.forEach(iframe => iframe.classList.remove("full-drawer"));
    windowParent.querySelectorAll(".page-iframe")?.forEach(iframe => iframe.classList.remove("full-drawer-content"));
    windowParent.querySelector(":scope > .row:nth-child(2)")?.querySelector("#myBuilder")?.classList.remove("m-0");
    windowParent.querySelector(":scope > .row:nth-child(2)")?.querySelector(".tab-pane.active")?.classList.remove("p-0", "m-0");
    // windowParent.querySelector(":scope > .row:last-child")?.classList.remove("d-none");
    window.parent.document.querySelector(".component-settings")?.querySelector(".formio-dialog-close")?.classList.remove("d-none");
    windowParent.querySelector("#element1")?.querySelector(":scope > .formio-component-tabs")?.querySelector(":scope > div > .nav-tabs")?.classList.remove("d-none");
    windowParent.querySelector("#element1")?.querySelector(":scope > .formio-component-tabs")?.querySelector(":scope .formio-component-validationSubTabs .nav-tabs")?.classList.remove("d-none");
  }

  public isDeterminantEmpty(jsonDeterminants: any): boolean {
    // console.log("isDeterminantEmpty", jsonDeterminants, JSON.parse(jsonDeterminants));
    if (jsonDeterminants) {
      let dets;
      if (jsonDeterminants instanceof Array || typeof jsonDeterminants === "object") {
        dets = jsonDeterminants[0]?.items;
      } else {
        dets = JSON.parse(jsonDeterminants)[0]?.items;
      }
      if (dets && dets.length > 0) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
    return true;
  }

  private load() {
    if (Array.isArray(this.tabComponentData[this.propKey])) {
      this.validations = this.tabComponentData[this.propKey];
    }
  }

  public updateDeterminant(event: any) {
    if (this.selectedRow && !this.isDeterminantEmpty(this.tempDeterminant)) {
      this.selectedRow.determinants = this.tempDeterminant;
      this.save();
    }
    this.closeDeterminantLayer();
  }

  public save() {
    this.tabComponentData[this.propKey] = this.validations;
    const data = {key: this.componentKey};
    data[this.propKey] = this.validations;
    console.log(data);
    window.top.postMessage([{channel: "FormBuilder", message: JSON.stringify(data)}], "*");
  }

  public deleteRow(index: number): void {
    this.validations.splice(index, 1);
    this.save();
  }

  public ngOnDestroy(): void {
    this.messageBridge.removeAllListeners("FormBuilder");
  }

  public onRequiredRowsChanged(): void {
    this.save();
  }

  public readonly JSON = JSON;
}
